export const TREND_SECTION_HELP_TEXT =
  'Questa vista mostra l’andamento temporale dei segnali su dati effettivi ripuliti. La linea principale rappresenta la media del gruppo; la banda attorno alla linea mostra quanto i soggetti sono variabili tra loro. Se attivi le sessioni overlay, puoi confrontare il singolo soggetto con la media del gruppo.';

export const TREND_SIGNAL_TOOLTIP =
  'Scegli la feature da osservare. I toggle accanto ti permettono di attivare normalizzazione e filtro passabasso sulla vista corrente del grafico.';

export const TREND_NORMALIZATION_TOOLTIP =
  'Normalizzazione z-score: per ogni sessione si sottrae la media della traccia e si divide per la sua deviazione standard.';

export const TREND_LOW_PASS_TOOLTIP =
  'Filtro passabasso forward-backward: smussa il segnale riducendo le oscillazioni più rapide e rumorose senza introdurre sfasamento visibile.';

export const TREND_NORMALIZATION_DISCLAIMER =
  'Regola di normalizzazione applicata: per ogni sessione si calcola uno z-score sulla traccia mostrata, sottraendo la media della sessione e dividendo per la sua deviazione standard. In questa vista conta quindi la forma relativa del cambiamento, non il valore assoluto originale.';

export const TREND_LOW_PASS_DISCLAIMER =
  'Filtro passabasso applicato: la curva viene smussata con lo stesso low-pass già usato nella pipeline analitica, per ridurre il rumore visivo e rendere più leggibile l’andamento medio del segnale.';

export const buildTrendViewDescription = (
  normalizationEnabled: boolean,
  lowPassEnabled: boolean
) =>
  [
    'Vista temporale del segnale selezionato su dati effettivi (riparati se disponibili, altrimenti originali).',
    normalizationEnabled
      ? 'La normalizzazione è attiva: i valori non vanno letti come unità assolute, ma come scostamenti relativi rispetto al profilo della singola sessione.'
      : 'In questa vista il segnale mantiene i suoi valori reali ripuliti.',
    lowPassEnabled
      ? 'Il filtro passabasso è attivo: la curva è smussata per ridurre il rumore visivo.'
      : 'Il filtro passabasso è disattivo: il grafico mostra il segnale ripulito senza smoothing aggiuntivo.',
  ].join(' ');

export const buildTrendProcessingDisclaimer = (
  normalizationEnabled: boolean,
  lowPassEnabled: boolean
) =>
  [
    normalizationEnabled ? TREND_NORMALIZATION_DISCLAIMER : null,
    lowPassEnabled ? TREND_LOW_PASS_DISCLAIMER : null,
  ]
    .filter(Boolean)
    .join(' ');

export const getTrendFeatureInterpretation = (
  signalLabel: string,
  normalized: boolean,
  lowPassFiltered: boolean
) => {
  if (normalized) {
    return {
      short: `${signalLabel} è mostrato in forma normalizzata per rendere più confrontabile l’andamento tra soggetti.`,
      detail: lowPassFiltered
        ? 'In questa modalità conta soprattutto la forma del cambiamento nel tempo. Il filtro passabasso smussa le oscillazioni più rumorose, quindi i valori non vanno letti come misura assoluta ma come scostamento relativo più leggibile.'
        : 'In questa modalità conta soprattutto la forma del cambiamento nel tempo. I valori non vanno letti come misura assoluta, ma come scostamento relativo rispetto al profilo della singola sessione.',
    };
  }

  if (signalLabel === 'HR') {
    return {
      short:
        'HR è mostrato in valori reali, quindi il livello assoluto è facilmente interpretabile.',
      detail: lowPassFiltered
        ? 'Esempio: 62 bpm, 78 bpm, 90 bpm. In più, con il filtro passabasso attivo, la curva viene smussata per ridurre il rumore visivo.'
        : 'Esempio: 62 bpm, 78 bpm, 90 bpm. Per HR il valore assoluto è già utile da leggere anche senza normalizzazione.',
    };
  }

  return {
    short: `${signalLabel} è mostrato in valori reali, ma può avere scale molto diverse tra soggetti.`,
    detail: lowPassFiltered
      ? `Per ${signalLabel} è spesso più utile osservare la forma del cambiamento nel tempo che confrontare solo i numeri assoluti tra persone diverse. Il filtro passabasso aiuta a leggere meglio il profilo medio del gruppo.`
      : `Per ${signalLabel} è spesso più utile osservare la forma del cambiamento nel tempo che confrontare solo i numeri assoluti tra persone diverse.`,
  };
};
